import * as t from "@rekajs/types";
export function componentSettingPropsToRekaProps(settingsProps) {
    return Object.entries(settingsProps).map(([name, config]) => {
        let kind;
        switch (config.type) {
            case "string":
                kind = t.stringKind();
                break;
            case "number":
                kind = t.numberKind();
                break;
            case "boolean":
                kind = t.booleanKind();
                break;
            case "enum":
                kind = t.stringKind();
                break;
            case "slider":
                kind = t.numberKind();
                break;
            case "colorPicker":
                kind = t.stringKind();
                break;
            case "file":
                kind = t.stringKind();
                break;
            case "html":
                kind = t.stringKind();
                break;
            case "style":
                kind = t.stringKind();
                break;
            case "image":
                kind = t.stringKind();
                break;
            case "array":
                kind = t.stringKind();
                break;
            case "object":
                kind = t.optionKind({
                    options: Object.entries(config.properties || {}).reduce((acc, [optionName, prop]) => (Object.assign(Object.assign({}, acc), { [optionName]: JSON.stringify(prop) })), {}),
                });
                break;
            default:
                throw new Error(`Unsupported prop type: ${config.type}`);
        }
        return t.componentProp({
            name,
            kind,
        });
    });
}
